module.exports = __webpack_public_path__ + "assets/img/sidebar-carrello-icon2.7b1ec80f.svg";